import { useCallback, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useFormState, useAzureStorage, useHandleRequest } from 'shared';
import { CONTAINERS } from 'pages/shared';

export function useTobaccoProductForm(product, onChangeInput) {
  const [productInputs, setProductInputs] = useFormState(product, onChangeInput);
  const { uploadFile } = useAzureStorage(CONTAINERS.TOBACCO_PRODUCTS);
  const { request, errorInfo: errorInfoFiles, setErrorInfo: setErrorInfoFiles } = useHandleRequest();

  useEffect(() => {
    setProductInputs({ ...product }, false);
  }, [product]);

  const handleChange =
    fieldName =>
    ({ target }) => {
      setProductInputs(inputs => ({ ...inputs, [fieldName]: target.value }));
    };

  const handleSelectFile = useCallback(
    async selectedFile => {
      await request(async () => {
        if (selectedFile) {
          const fileId = uuidv4();
          const urlFile = await uploadFile({ ...selectedFile, fileId: fileId });
          setProductInputs(inputs => ({ ...inputs, imageUrl: urlFile }));
        }
      });
    },
    [request, uploadFile]
  );

  function handleDeleteFile() {
    setProductInputs(prevInputs => ({
      ...prevInputs,
      imageUrl: ''
    }));
  }
  return {
    productInputs,
    handleChange,
    handleSelectFile,
    handleDeleteFile,
    errorInfoFiles
  };
}
